import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./highlighted-card.css.ts.vanilla.css-mistica.js";
var y = "wrb8722 _1y2v1nfhk _1y2v1nfhp _1y2v1nfhw _1y2v1nfi2", f = "wrb8725 _1y2v1nfhk", _ = {
    withImage: "wrb8728 wrb8727 _1y2v1nfhk _1y2v1nfhq _1y2v1nfhy _1y2v1nf7y _1y2v1nf97 _1y2v1nfaa",
    withoutImage: "wrb8729 wrb8727 _1y2v1nfhk _1y2v1nfhq _1y2v1nfhy _1y2v1nf7y _1y2v1nf97 _1y2v1nfaa"
}, a = "_1y2v1nf7d _1y2v1nf8m _1y2v1nf9v _1y2v1nfb4 _1y2v1nfhk _1y2v1nfi2 _1y2v1nfk2 _1y2v1nfi7 _1y2v1nf7c";
export { y as container, f as imageContent, _ as textContainerVariant, a as touchableContainer };
